'use strict';

var $slideshowOverlay = $("#slideshow-overlay");
var $slideshows = $(".slideshow");
var $currentSlideshow;
var $slideshowItems;
var animationTime = 275; //2x

var handleSlideshowOpener = function handleSlidshowOpener(evt) {
    evt.preventDefault();

    $slideshows.addClass('hide');
    $currentSlideshow = $('#slideshow-' + $(this).data('slideshow'));
    $slideshowItems = $currentSlideshow.find(".slideshow__item");

    if (!$currentSlideshow.data('imagesLoaded')) {
        $slideshowItems.each(function(index, elem) {
            var $img = $(elem).find('img');
            $img.attr('src', $img.data('src'));
        });

        $currentSlideshow.data('imagesLoaded', true);
    }

    $currentSlideshow.removeClass('hide');
    $slideshowItems.hide();
    $slideshowItems.eq(0)
        .addClass('slideshow-current-item')
        .show();

    $slideshowOverlay.addClass('open');
};

var handleSlideshowIconClick = function handleSlideshowIconClick(evt) {
    evt.preventDefault();

    var $currentItem = $slideshowItems.filter('.slideshow-current-item');
    var $nextItem;

    if ($(this).data('direction') === 'next') {
        $nextItem = $currentItem.next();
        if (!$nextItem.length) {
            $nextItem = $slideshowItems.eq(0);
        }
    } else {
        $nextItem = $currentItem.prev();
        if (!$nextItem.length) {
            $nextItem = $slideshowItems.last();
        }
    }

    $currentItem.fadeOut(animationTime, function() {
        $currentItem.removeClass('slideshow-current-item');
        $nextItem.fadeIn(animationTime, function() {
            $nextItem.addClass('slideshow-current-item');
        });
    })
};

module.exports = function() {
    $('.slideshow-opener').on('click', handleSlideshowOpener);
    $('.slideshow-container').on('click', '.slideshow-icon', handleSlideshowIconClick);
};



// WEBPACK FOOTER //
// ./resources/js/components/slideshow.js